export enum RoayltySplitListStatusEnum {
  ACTIVE = 'ACTIVE',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  PENDING = 'PENDING',
  INACTIVE = 'INACTIVE',
}
